import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="py-24 px-4 bg-black text-white text-center" data-id="element-52">
      <div className="max-w-4xl mx-auto" data-id="element-53">
        <h2 className="text-5xl md:text-7xl font-black text-yellow-400 mb-8 uppercase" data-id="element-54">
          👉 EMPEZAR AHORA
        </h2>

        <p className="text-3xl md:text-5xl font-black text-white mb-16" data-id="element-55">
          Dejá de pensar.
          <br data-id="element-56" />
          <span className="text-red-500" data-id="element-57">Empezá a ejecutar.</span>
        </p>

        <div className="bg-zinc-900 border border-zinc-800 p-8 md:p-12 rounded-2xl mb-12 text-left md:text-center" data-id="element-58">
          <p className="text-xl md:text-2xl font-bold text-gray-400 mb-6 uppercase tracking-widest" data-id="element-59">
            Porque la realidad es simple:
          </p>
          <div className="space-y-4 text-2xl md:text-4xl font-black text-white" data-id="element-60">
            <p data-id="element-61">👉 No necesitás más información</p>
            <p className="text-yellow-400" data-id="element-62">👉 Necesitás un sistema</p>
            <p data-id="element-63">👉 Y ejecutarlo todos los días</p>
          </div>
        </div>

        <CTAButton text="ACCEDER AL SISTEMA HOY" data-id="element-64" />
      </div>
    </section>;
}